// Public bundle - minimal JavaScript for static public pages (landing, privacy, terms, etc.)
// This bundle excludes LiveView to optimize bundle size for pages that don't need it

// Include phoenix_html to handle method=PUT/DELETE in forms and buttons.
import "phoenix_html";

// Alpine.js for interactivity (without persist plugin for public pages)
import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start();

// Import ColorSchemeHook for theme switching
import ColorSchemeHook from "./hooks/color-scheme-hook";

// Landing page specific imports
import "./lib/box-highlighter";

// Initialize ColorScheme for all color scheme switches on the page
function initColorScheme() {
  // Find all color scheme switches and initialize them
  document.querySelectorAll('[phx-hook="ColorSchemeHook"]').forEach(el => {
    // Initialize the color scheme (show correct icon)
    if (window.initScheme) {
      window.initScheme();
    }
    
    // Add click handler
    el.addEventListener('click', () => {
      if (window.toggleScheme) {
        window.toggleScheme();
      }
    });
  });
}

// Initialize testimonials when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  initColorScheme();
});